var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 42,
    height: 42,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.2 25.3c3.3 1.1 8.1 3.5 8.7 7.4.3 2.3-.3 4.5-1.4 6.5-.7 1.3-3.7 3.6-3.7 3.6a9049.8 9049.8 0 001.7 4.5c.2.5 0 1-.7.6l-6-2.9-1.3.6c-2 .5-3.9.8-5.8.9-3.8.1-8-.5-11.2-2.6a9.9 9.9 0 01-4.4-9.6c.5-4.8 4.5-7.7 8.8-9a25 25 0 0115.3 0z",
    fill: "#193448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7 22.7a23 23 0 01-6.9-.7l-1.2-.5-5 2.4c-.6.3-.8 0-.6-.5l.4-1 1-2.7s-2.5-2-3.1-3A8.4 8.4 0 014 11.3C4.6 8 8.6 6 11.5 5c4.2-1.5 8.7-1.4 13 0 3.6 1.1 7 3.5 7.4 7.5l.1.7c0 3-1.3 5.6-3.8 7.3a15 15 0 01-7.5 2.1z",
    fill: "#193448"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7 21.1a25.5 25.5 0 01-7.8-.8l-1.3-.5L4 22.4c-.7.4-.8 0-.7-.5l.5-1.2 1.1-3s-2.8-2.2-3.5-3.4c-1-1.9-1.6-4-1.3-6 .5-3.8 5-6 8.2-7 4.8-1.7 9.8-1.7 14.5-.1 4 1.3 7.9 4 8.4 8.5v.8a9.3 9.3 0 01-4.2 8.2 16.6 16.6 0 01-8.3 2.4z",
    fill: "#F19020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 8c.5-2 3.7-1.7 3.6.5 0 1.2-1 1.7-1.7 2.4-.6.5-1 1.3-1.2 2-.2.7.9 1 1 .3.3-1.4 1.7-2 2.5-3a3 3 0 00-.2-3.7c-1.4-1.8-4.5-.8-5 1.3-.3.6.8.9 1 .2zm.5 6.7a.5.5 0 111 0 .5.5 0 01-1 0z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 19.1c4.2 1.4 10.2 4.3 10.9 9.2.4 2.8-.4 5.5-1.8 8-.9 1.5-4.6 4.4-4.6 4.4l1 2.7 1.1 2.9c.3.6 0 1.1-.8.7l-7.4-3.5-1.8.6a33.4 33.4 0 01-7.1 1.1c-4.8.2-10-.5-14-3.1A12.1 12.1 0 017 30.2c.7-5.9 5.7-9.4 11-11.1 1.8-.6 3.6-1 5.5-1.3A29.7 29.7 0 0137 19.1z",
    fill: "#127CCB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 36.2a2.4 2.4 0 114.8-.2 2.4 2.4 0 01-4.8.2z",
    fill: "#5FCE8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 29.8a2.4 2.4 0 114.9-.2 2.4 2.4 0 01-4.9.2z",
    fill: "#FBAF17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 34c.6-.5 1.2-1 2-1 1.1-.2 1.2 1.4 1.1 2.1 0 1.1-.4 2.3-.5 3.4-.3 2.1 1.2 3.2 3.1 3.3 4.3.3 4.1-5.4 3.5-8.1a12.2 12.2 0 00-.8-2.4c-.6-1.3-1.8-2.3-1.5-3.9.3-1.5 1.8-3.4 3.4-3.8 1.1-.3 3.2.6 3.6 1.8.3.9-.8 2.5-1 3.4 0 1.3 0 2.5.9 3.6 1.5 1.8 4 2 6 .7.7-.5 0-1.7-.8-1.2-1.5 1-3.3.8-4.4-.7-1-1.5.2-3.3.6-4.7.6-2.2-1.3-3.5-3-4-2.3-.8-4.2.3-5.4 2.1-.7 1.1-1.3 2.2-1.4 3.5 0 1.3 1 2.5 1.6 3.5 1 1.7 1.3 3.9 1.2 5.8 0 1-.3 1.9-1 2.5-.8 1-3.1.6-3.3-.7-.2-2.4 1.2-4.2.1-6.5-1-2.1-3.7-.8-5 .3-.6.6.4 1.5 1 1z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4 21.1h2.3c2.9-.1 5.8-.8 8.3-2.4a9.6 9.6 0 001.4-1.2 30 30 0 00-5 .3c-1.8.3-3.6.7-5.4 1.3a22.6 22.6 0 00-4.2 1.8l2.6.2z",
    fill: "#0A3B5F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d7ac354c71fa574e4519d80f95766f5d.svg";
export { ForwardRef as ReactComponent };